exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".office-info>h2{margin-top:0}.office-info .info-list li span:not(.fa){display:block}.office-info .info-list li span:not(.fa).header{text-transform:uppercase;font-weight:700;font-size:18px;margin-top:10px}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/offices/client/app/components/offices/office/office.scss"],"names":[],"mappings":"AAAA,gBAEI,YAAa,CAFjB,yCAMI,aAAc,CANlB,gDASM,yBACA,gBACA,eACA,eAAgB,CACjB","file":"office.scss","sourcesContent":[".office-info {\n  > h2 {\n    margin-top: 0;\n  }\n\n  .info-list li span:not(.fa) {\n    display: block;\n\n    &.header {\n      text-transform: uppercase;\n      font-weight: bold;\n      font-size: 18px;\n      margin-top: 10px;\n    }\n  }\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sass-loader?sourceMap!./client/app/components/offices/office/office.scss
// module id = 599
// module chunks = 0